import { create } from 'zustand';

type ContentLocale = 'de' | 'en';

interface AdminLocaleState {
  contentLocale: ContentLocale;
  setContentLocale: (locale: ContentLocale) => void;
}

export const useAdminLocale = create<AdminLocaleState>((set) => ({
  contentLocale: 'de',
  setContentLocale: (locale) => set({ contentLocale: locale }),
}));
